export default {
  getPageable: (state) => {
    return state.pageable;
  },
  getPrivatePlotFeaturesForPoint: (state) => {
    return state.features.filter((f) => f.geometry.type === "Point");
  },
  getPrivatePlotFeaturesForPolygon: (state) => {
    return state.features.filter((f) => f.geometry.type === "Polygon");
  },
  getPoints: (state) => state.points.toArray(),
  getEditMode: (state) => state.editMode, // 1: point, 2: text
  // 管理メニュー、右メニュー用のプライベートプロット
  // 引数のenterpriseIdが存在する場合は法人IDによる絞り込みが処理が追加される。
  getEnterprisePrivatePlots:
    (state) =>
    (enterpriseId = null) => {
      if (!state.privatePlots.length) return [];
      const filteredPrivatePlots = state.privatePlots.filter((plot) => {
        // 組織が異なるものはメニューに表示しない
        if (enterpriseId && plot.enterprise_id !== enterpriseId) {
          return false;
        }
        // 表示期間がないものは表示する
        if (!plot.start_date && !plot.end_date) {
          return true;
        }
        const now = new Date();

        // 管理メニュー・右メニューでは開始日時前でも表示するので、開始日時前のフィルタリングは不要

        // 表示終了日時を過ぎた場合は削る
        if (plot.end_date && plot.end_date.toDate() < now) {
          return false;
        }
        // 表示期間内のものは組織が同じであれば表示する
        return true;
      });
      // 登録日時降順で表示する
      return filteredPrivatePlots.sort((a, b) => {
        return b.created_at.toDate() - a.created_at.toDate();
      });
    },
};
